<div class="finance-list-page">
    <app-page-shell>
        <p-toast position="top-center"></p-toast>
        <p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

        <app-page-hero [eyebrow]="t('pages.generatedInvoices.hero.eyebrow')" [title]="t('pages.generatedInvoices.hero.title')"
            [subtitle]="t('pages.generatedInvoices.hero.subtitle')">
            <div actions>
                <p-button [label]="t('pages.invoiceDispatch.title')" icon="pi pi-send" severity="secondary" [outlined]="true"
                    (click)="openInvoiceDispatches()"></p-button>
                <p-button *ngIf="canEditInvoice && !isConsolidatedReadOnly" [label]="t('pages.generatedInvoices.actions.manualDraft')" icon="pi pi-plus"
                    severity="secondary" [outlined]="true" (click)="createManualInvoiceDraft()"></p-button>
                <p-button *ngIf="canGenerateReceipt && !isConsolidatedReadOnly" [label]="t('pages.generatedInvoices.actions.generateReceipt')" icon="pi pi-receipt"
                    severity="help" (click)="generateReceipt()" [disabled]="!selectedInvoices.length"></p-button>
                <p-button [label]="t('pages.generatedInvoices.actions.export')" icon="pi pi-file-excel" severity="secondary" [outlined]="true"
                    (click)="exportToExcel()"></p-button>
            </div>
        </app-page-hero>

        <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

        <app-page-search-panel [title]="t('pages.generatedInvoices.search.title')" [activeFilters]="activeFilterCount"
            [resultText]="resultText" [collapsed]="true" (search)="applyFilters()" (clear)="clearFilters()">
            <div class="finance-search-grid">
                <app-company-scope-selector (scopeChange)="onScopeChange($event)"></app-company-scope-selector>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-users"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="client" [options]="clients" [(ngModel)]="selectedClients"
                                optionLabel="name" display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="client">{{ t('pages.generatedInvoices.search.customers') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-datePicker inputId="dateRange" [(ngModel)]="dateRange" selectionMode="range"
                                [readonlyInput]="true" dateFormat="yy-mm-dd" appendTo="body"
                                styleClass="w-full"></p-datePicker>
                            <label for="dateRange">{{ t('pages.generatedInvoices.search.invoiceDateRange') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="status" [options]="statusOptions" [(ngModel)]="selectedStatuses" optionLabel="label" optionValue="value"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="status">{{ t('pages.generatedInvoices.search.status') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="documentStatus" [options]="documentStatusOptions" [(ngModel)]="selectedDocumentStatuses" optionLabel="label" optionValue="value"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="documentStatus">{{ t('pages.generatedInvoices.search.documentStatus') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-clock"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-select inputId="dueStatus" [options]="dueStatusOptions" [(ngModel)]="selectedDueStatus"
                                [showClear]="true" styleClass="w-full"></p-select>
                            <label for="dueStatus">{{ t('pages.generatedInvoices.search.dueStatus') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-send"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="sentStatus" [options]="sentStatusOptions" [(ngModel)]="selectedSentStatuses"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="sentStatus">{{ t('pages.generatedInvoices.search.sentStatus') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-shield"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="zatcaStatus" [options]="zatcaStatusOptions" [(ngModel)]="selectedZatcaStatuses"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="zatcaStatus">{{ t('pages.generatedInvoices.search.zatcaStatus') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="collectionStatus" [options]="collectionStatusOptions" [(ngModel)]="selectedCollectionStatuses"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="collectionStatus">{{ t('pages.generatedInvoices.search.collectionStatus') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-dollar"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <input id="currencyCode" type="text" pInputText [(ngModel)]="currencyCodeFilter" />
                            <label for="currencyCode">{{ t('pages.generatedInvoices.search.currency') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-sort-amount-up"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-inputNumber inputId="amountMin" [(ngModel)]="amountMinFilter" mode="decimal" [minFractionDigits]="2"
                                styleClass="w-full"></p-inputNumber>
                            <label for="amountMin">{{ t('pages.generatedInvoices.search.amountMin') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-sort-amount-down"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-inputNumber inputId="amountMax" [(ngModel)]="amountMaxFilter" mode="decimal" [minFractionDigits]="2"
                                styleClass="w-full"></p-inputNumber>
                            <label for="amountMax">{{ t('pages.generatedInvoices.search.amountMax') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <input id="invoiceNumber" type="text" pInputText [(ngModel)]="invoiceNumberFilter" />
                            <label for="invoiceNumber">{{ t('pages.generatedInvoices.search.invoiceNumber') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>
            </div>
        </app-page-search-panel>

        <app-page-data-panel [title]="t('pages.generatedInvoices.dataPanel.title')"
            [subtitle]="t('pages.generatedInvoices.dataPanel.subtitle')"
            [resultText]="resultText">
            <div actions>
                <p-button [label]="t('pages.generatedInvoices.actions.export')" icon="pi pi-file-excel" severity="secondary" [outlined]="true"
                    (click)="exportToExcel()"></p-button>
            </div>

            <div class="bulk-action-bar" *ngIf="selectedInvoices.length && !isConsolidatedReadOnly">
                <div>
                    <strong>{{ selectedInvoices.length }}</strong> {{ t('pages.generatedInvoices.bulk.selected') }},
                    <strong>{{ formatMoney(getSelectedTotal()) }}</strong>
                </div>
                <div class="bulk-actions">
                    <p-button *ngIf="canGenerateReceipt" [label]="t('pages.generatedInvoices.actions.generateReceipt')" icon="pi pi-receipt"
                        severity="help" (click)="generateReceipt()" [disabled]="!selectedInvoices.length"></p-button>
                </div>
            </div>

            <app-accounting-directory-controls documentType="INVOICE" [filters]="directoryFilters"
                [searchText]="searchText" [selectedStatuses]="selectedDocumentStatuses" [pendingStatuses]="pendingStatuses" (searchTextChange)="onDirectorySearch($event)"
                (modeChange)="onDirectoryModeChange($event)" (pending)="showPendingStatuses()"
                (all)="showAllStatuses()"></app-accounting-directory-controls>
            <p-table *ngIf="directoryMode === 'LIST'" class="finance-table" [value]="allInvoices" dataKey="invoiceId" [paginator]="true"
                [rows]="rows" [first]="first" [showCurrentPageReport]="true" [totalRecords]="totalRecords"
                [lazy]="true" [currentPageReportTemplate]="currentPageReportTemplate"
                (onLazyLoad)="loadData($event)" [rowsPerPageOptions]="[20, 50, 100]"
                [(selection)]="selectedInvoices" [tableStyle]="{ 'min-width': '0' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3.5rem"><p-tableHeaderCheckbox *ngIf="!isConsolidatedReadOnly"></p-tableHeaderCheckbox></th>
                        <th>{{ t('pages.generatedInvoices.table.invoice') }}</th>
                        <th>{{ t('pages.generatedInvoices.table.customer') }}</th>
                        <th>{{ t('pages.generatedInvoices.table.amounts') }}</th>
                        <th>{{ t('pages.generatedInvoices.table.paymentZatcaStatus') }}</th>
                        <th>{{ t('pages.generatedInvoices.table.datesCollections') }}</th>
                        <th>{{ t('pages.generatedInvoices.table.actions') }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-invoice>
                    <tr>
                        <td [attr.data-label]="t('pages.generatedInvoices.table.select')"><p-tableCheckbox *ngIf="!isConsolidatedReadOnly" [value]="invoice"></p-tableCheckbox></td>
                        <td [attr.data-label]="t('pages.generatedInvoices.table.invoice')">
                            <div class="stack-cell">
                                <span class="cell-title">{{ invoice.invoiceNumber || t('pages.generatedInvoices.table.noInvoiceNumber') }}</span>
                                <div class="cell-meta">
                                    <span class="code-pill">{{ t('pages.generatedInvoices.table.id') }} {{ invoice.invoiceId || '-' }}</span>
                                    <span>{{ invoice.invoiceType || t('pages.generatedInvoices.table.standard') }}</span>
                                </div>
                            </div>
                        </td>
                        <td [attr.data-label]="t('pages.generatedInvoices.table.customer')">
                            <div class="stack-cell">
                                <span class="cell-title">{{ crmPartyContext.displayName(invoice) }}</span>
                                <div class="cell-meta">{{ t('pages.generatedInvoices.table.contact') }}: {{ crmPartyContext.contactDisplayName(invoice) }}</div>
                            </div>
                        </td>
                        <td [attr.data-label]="t('pages.generatedInvoices.table.amounts')">
                            <div class="amount-block">
                                <span class="amount-primary">{{ invoice.totalAmount | currency:invoice.country?.currencyCode:(invoice.country?.currencyCode || 'SAR') + ' ' }}</span>
                                <span class="amount-secondary">{{ t('accountingAmounts.beforeTax') }} {{ invoice.totalAmountExclTax != null ? (invoice.totalAmountExclTax | currency:invoice.country?.currencyCode:(invoice.country?.currencyCode || 'SAR') + ' ') : '—' }}</span>
                                <span class="amount-secondary">{{ t('pages.generatedInvoices.table.open') }} {{ getOpenAmount(invoice) | currency:invoice.country?.currencyCode:(invoice.country?.currencyCode || 'SAR') + ' ' }}</span>
                                <span class="amount-secondary">{{ t('pages.generatedInvoices.table.tax') }} {{ invoice.totalTax | currency:invoice.country?.currencyCode:(invoice.country?.currencyCode || 'SAR') + ' ' }}</span>
                            </div>
                        </td>
                        <td [attr.data-label]="t('pages.generatedInvoices.table.paymentZatcaStatus')">
                            <div class="status-stack">
                                <p-tag [severity]="statusSeverity(invoice.documentStatus)" [value]="documentStatusLabel(invoice.documentStatus)"></p-tag>
                                <p-tag [severity]="statusSeverity(invoice.status)" [value]="paymentStatusLabel(invoice.status)"></p-tag>
                                <span class="muted-pill">{{ t('pages.generatedInvoices.table.zatca') }} {{ invoice.zatcaStatus || t('pages.generatedInvoices.table.notAvailable') }}</span>
                            </div>
                        </td>
                        <td [attr.data-label]="t('pages.generatedInvoices.table.datesCollections')">
                            <div class="stack-cell">
                                <span class="cell-title">{{ invoice.invoiceCreationDate | date:'yyyy-MM-dd' }}</span>
                                <div class="cell-meta vertical">
                                    <span>{{ t('pages.generatedInvoices.table.created') }} {{ invoice.createdAt | date:'yyyy-MM-dd' }}</span>
                                    <span>{{ t('pages.generatedInvoices.table.due') }} {{ invoice.dueDate | date:'yyyy-MM-dd' }}</span>
                                    <span *ngIf="invoice.issuerName">Issued by {{ invoice.issuerName }}</span>
                                    <span>{{ t('pages.generatedInvoices.table.receiptsLinked', { count: invoice.receipts?.length || 0 }) }}</span>
                                </div>
                            </div>
                        </td>
                        <td [attr.data-label]="t('pages.generatedInvoices.table.actions')">
                            <div class="row-actions">
                                <p-button icon="pi pi-eye" [rounded]="true" [text]="true" [pTooltip]="t('pages.generatedInvoices.tooltips.viewInvoice', 'View invoice')"
                                    (click)="viewInvoice(invoice)"></p-button>
                                <p-button *ngIf="canEditDraftInvoice(invoice)" icon="pi pi-pencil" [rounded]="true" [text]="true"
                                    severity="secondary" [pTooltip]="t('pages.generatedInvoices.tooltips.editDraft', 'Edit draft')" (click)="editInvoice(invoice)"></p-button>
                                <p-button *ngIf="!isConsolidatedReadOnly && invoice.documentStatus === 'APPROVED' && invoice.postingStatus !== 'POSTED'"
                                    icon="pi pi-check" [rounded]="true" [text]="true" severity="success"
                                    [pTooltip]="t('pages.generatedInvoices.tooltips.postInvoice', 'Post invoice')" (click)="postInvoice(invoice)"></p-button>
                                <p-button icon="pi pi-list" [rounded]="true" [text]="true" [pTooltip]="t('pages.generatedInvoices.tooltips.previewLines', 'Preview lines')"
                                    (click)="openPreview(invoice)"></p-button>
                                <app-finance-pdf-view-button kind="invoice" [documentId]="invoice.invoiceId" [documentReference]="invoice.invoiceNumber" [postingStatus]="invoice.postingStatus" [iconOnly]="true" [disabled]="documentActions.isPending(invoice.invoiceId)"></app-finance-pdf-view-button>
                                <p-button [icon]="invoice.postingStatus === 'POSTED' ? 'pi pi-download' : 'pi pi-print'" [rounded]="true" [text]="true" severity="info" [loading]="documentActions.isPending(invoice.invoiceId)"
                                    [pTooltip]="invoice.postingStatus === 'POSTED' ? t('pages.generatedInvoices.tooltips.downloadInvoice', 'Download Invoice') : 'Print / reprint draft from latest saved changes'" (click)="downloadInvoice(invoice)"></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">
                            <div class="empty-state">
                                <i class="pi pi-inbox"></i>
                                <strong>{{ t('pages.generatedInvoices.empty.title') }}</strong>
                                <span>{{ t('pages.generatedInvoices.empty.subtitle') }}</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </app-page-data-panel>
    </app-page-shell>

    <p-drawer [(visible)]="isPreviewVisible" position="right" styleClass="finance-preview-drawer">
        <ng-template pTemplate="header">
            <div class="stack-cell">
                <strong>{{ previewInvoice?.invoiceNumber || t('pages.generatedInvoices.preview.invoiceLines') }}</strong>
                <span class="cell-meta">{{ t('pages.generatedInvoices.preview.lineCount', { count: previewInvoice?.invoiceLines?.length || 0 }) }}</span>
            </div>
        </ng-template>
        <div class="preview-list" *ngIf="previewInvoice?.invoiceLines?.length; else noInvoiceLines">
            <div class="preview-line" *ngFor="let line of previewInvoice?.invoiceLines">
                <div class="preview-line-header">
                    <div>
                        <div class="preview-line-title">{{ line.itemNumber || line.itemDescription || t('pages.generatedInvoices.preview.lineItem') }}</div>
                        <div class="cell-meta">{{ line.headerReferenceNumber }} / {{ line.detailReferenceNumber }}</div>
                        <div class="cell-meta" *ngIf="line.itemDescriptionLocal" dir="rtl">{{ line.itemDescriptionLocal }}</div>
                        <div class="cell-meta" *ngIf="line.invoiceComment">{{ line.invoiceComment }}</div>
                    </div>
                    <div class="preview-line-amount">{{ formatMoney(line.chargeAmount, previewInvoice?.country?.currencyCode) }}</div>
                </div>
            </div>
        </div>
        <ng-template #noInvoiceLines>
            <div class="preview-empty">{{ t('pages.generatedInvoices.preview.noLines') }}</div>
        </ng-template>
    </p-drawer>
</div>
